import { Drawer, ListItemButton, styled } from '@mui/material';
import sideBarImg from 'new/assets/navbar-img.jpg';
import { TENANT } from 'new/tenants';
import { BANNER_HEIGHT } from '../GlobalBanner';
import { borderRadius } from 'new/constants/styles';
import { TenantStruct } from 'new/types/util';

const CustomDrawerVHQ = styled(Drawer, {
  shouldForwardProp: (prop) => !['showBanner'].includes(prop as string),
})<{ showBanner: boolean }>(({ theme, showBanner }) => ({
  position: 'relative',

  '.MuiDrawer-paper': {
    width: 'inherit',
    flexShrink: 0,
    backgroundColor: theme.palette.misc.sidebarBackground,
    backgroundImage: `url(${sideBarImg})`,
    backgroundSize: 'cover',
    overflowY: 'visible',
    borderRight: 'none',
    paddingTop: showBanner ? BANNER_HEIGHT : 0,
  },
  a: {
    color: 'white',
    textDecoration: 'none',
  },

  '.MuiCollapse-wrapperInner': {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));

const CustomDrawerDHQ = styled(Drawer, {
  shouldForwardProp: (prop) =>
    !['isSuperAdminSidebar', 'showBanner'].includes(prop as string),
})<{ isSuperAdminSidebar?: boolean; showBanner: boolean }>(
  ({ theme, isSuperAdminSidebar, showBanner }) => ({
    position: 'relative',

    '.MuiDrawer-paper': {
      width: 'inherit',
      flexShrink: 0,
      background: isSuperAdminSidebar
        ? theme.palette.misc.sidebarAdminBackground
        : theme.palette.misc.sidebarBackground,
      overflowY: 'visible',
      borderRight: 'none',
      paddingTop: showBanner ? BANNER_HEIGHT : 0,
    },
    a: {
      color: 'white',
      textDecoration: 'none',
    },

    '.MuiCollapse-wrapperInner': {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
  }),
);

const customDrawer: TenantStruct<
  typeof CustomDrawerVHQ | typeof CustomDrawerDHQ
> = {
  vhq: CustomDrawerVHQ,
  dhq: CustomDrawerDHQ,
};

export const CustomDrawer = customDrawer[TENANT.id];

const CustomListItemVHQ = styled(ListItemButton)(({ theme }) => ({
  padding: '4px 16px 4px',
  '&.MuiListItemButton-root': {
    svg: {
      width: '28px',
      height: '16px',
      margin: '0 5px',
    },
    '&:hover': {
      backgroundColor: theme.palette.dhqGray.main,
    },
    '&.disabled': {
      color: 'rgba(221, 221, 221, 0.5)',
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.dhqBlue.main,
    },
  },

  '&.isSuperAdmin': {
    margin: theme.spacing(0, 1),
    padding: theme.spacing(0.5, 1),
    borderRadius,
  },

  '.listItemIcon': {
    color: '#ddd',
  },
}));

const CustomListItemDHQ = styled(ListItemButton)(({ theme }) => ({
  '.MuiTypography-root, .listItemIcon': {
    color: theme.palette.grey[500],
  },
  '&.isSuperAdminSidebar': {
    '.MuiTypography-root, .listItemIcon': {
      color: theme.palette.primary.dark,
      fontWeight: 500,
    },
  },
  '&.MuiListItemButton-root': {
    svg: {
      width: '28px',
      height: '16px',
      margin: '0 5px',
    },
    '&:hover': {
      backgroundColor: theme.palette.dhqBlack.light,
      '&.isSuperAdminSidebar': {
        backgroundColor: theme.palette.blueGrey[400],
        '.MuiTypography-root, .listItemIcon': {
          color: theme.palette.grey[800],
        },
      },
    },
    '&.disabled': {
      color: 'rgba(221, 221, 221, 0.5)',
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.blueGrey[600],
      '&.isSuperAdminSidebar': {
        backgroundColor: theme.palette.common.white,
      },
    },
  },

  margin: theme.spacing(0, 1),
  padding: theme.spacing(0.5, 1),
  borderRadius,
}));

const customListItem: TenantStruct<
  typeof CustomListItemVHQ | typeof CustomListItemDHQ
> = {
  vhq: CustomListItemVHQ,
  dhq: CustomListItemDHQ,
};

export const CustomListItem = customListItem[TENANT.id];
